var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userStockListHome"},[(_vm.$vuetify.breakpoint.mobile)?_c('UserStockWatchingListMobile',{attrs:{"id":this.id,"list":this.list,"stockId":this.stockId}}):_c('UserStockWatchingList',{attrs:{"id":this.id,"list":this.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }